<template>
  <DrawerBottom
    @toggle="$emit('toggle-drawer', !openDrawer)"
    :open="openDrawer"
  >
    <template #content>
      <main class="DrawerBottomPayment">
        <div class="DrawerBottomPayment__message">
          <div class="message__text">
            <h1 class="text__title">Deseja pagar no guichê?</h1>
            <p class="text__info">
              Ao pagar online você não passa pelo guichê e evita filas.
            </p>
          </div>
        </div>

        <div class="button__group">
          <button
            class="action button"
            @click="payWithCreditCard"
          >
             <span>Mudar forma de pagamento</span>
          </button>
          <VButton
            class="action"
            text="Continuar para pagar no guichê"
            variant="secondary"
            width="100%"
            @click.native="paymentWithoutCreditCard"
          />
        </div>
      </main>
    </template>
  </DrawerBottom>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DrawerBottom from '@/components/drawerBottom.component.vue';

export default {
  components: {
    DrawerBottom,
  },
  props: {
    openDrawer: {
      type: Boolean,
      default: false,
    },
    pixPaymentEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      isVaccineFlow: 'global/isVaccineFlow',
    }),
  },
  methods: {
    ...mapActions({
      setAdmissionNotElegible: 'setAdmissionNotElegible'
    }),
    async paymentWithoutCreditCard() {
      await this.setAdmissionNotElegible();
      /* eslint-disable */
      dataLayer.push({
        event: 'forma_pagamento',
        forma_pagamento_escolhida: 'guiche'
      });

      this.$emit('payment-without-card');

      if(this.isVaccineFlow) return this.goNextStep('queue_end_flow')
      /* eslint-enable */
      this.goNextStep('end_flow_success');
    },
    payWithCreditCard() {
      /* eslint-disable */
      dataLayer.push({
        event: 'forma_pagamento',
        forma_pagamento_escolhida: 'cartão de crédito'
      });
      /* eslint-enable */
      this.$emit('credit-payment');
    },
    payWithOtherMethods() {
      /* eslint-disable */
      dataLayer.push({
        event: 'forma_pagamento',
        forma_pagamento_escolhida: 'mudar forma de pagamento'
      });
      /* eslint-enable */
      this.$emit('payment-other-methods');
    }
  }
};
</script>

<style lang="scss" scoped>
.DrawerBottomPayment {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  &__message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 40%;
    max-width: 100%;
    margin-top: 0px;

    .message {
      &__icon {
        &--credit-card {
          fill: var(--color-primary);
        }
      }

      &__text {
        .text__title {
          color: #161616;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          padding: 16px 16px 24px;
        }

        .text__info {
         font-size: 16px;
         line-height: 18.75px;
         font-weight: 400;
         color: var(--color-grey-11);
         padding-bottom: 8px;
        }
      }
    }
  }

  .button__group {
    width: 100%;
    button {
      display: flex;
      min-width: 264px;
      height: 48px;
      margin-bottom: 16px;
      width: 100%;
      background-color: var(--color-button-primary);
      color: #fff;
      justify-content: center;
      align-items: center;
      padding: 2px 8px;
      line-height: 150%;
      font-weight: 600;
      text-align: center;
      border: 1px solid transparent;
      border-radius: 4px;
      font-size: var(--font-size-3);

      .icon {
        transform: scale(.6);

        path {
          fill: #fff;
        }
      }
    }
  }

  .action {
    margin-top: 16px;
    min-width: 100%;

    &:last-of-type {
      border-color: transparent;
      background-color: transparent;
      color: var(--color-primary);
    }
  }
}
</style>
